<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="params.value == 'loading'" class="sloader"></div>
		<div v-else-if="params.value == '402'">
			<vx-tooltip
				text="Limite de crédit atteinte. Réessayer demain"
				placement="top"
			>
				<feather-icon
					icon="CloudOffIcon"
					class="m-0 cursor-pointer"
					style="color: #949494"
				/>
			</vx-tooltip>
		</div>
		<a
			v-else
			target="_blank"
			:href="params.value.links.report_url"
			class="flex justify-end cursor-pointer"
		>
			<vs-chip
				:color="getGtMEtrixColor(params.value.attributes.gtmetrix_grade)"
				class="text-align-right"
			>
				<span>
					&nbsp;&nbsp;{{ params.value.attributes.gtmetrix_grade }}&nbsp;&nbsp;
				</span>
			</vs-chip>
		</a>
	</div>
</template>
  
  <script>
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
export default {
	mixins: [utilsMixin, dbFieldConvertorMixin],
	created() {
		console.log("Value received GT METRIXC:", this.params.value);
	},
	methods: {
		getGtMEtrixColor(val) {
			let colNum = 1;
			if (val == "A") colNum = 1;
			else if (val == "B") colNum = 17;
			else if (val == "C") colNum = 33;
			else if (val == "D") colNum = 49;
			else if (val == "E") colNum = 65;
			else if (val == "F") colNum = 81;
			else if (val == "G") colNum = 97;
			else colNum = 99;
			return this.getGradColor(colNum);
		},
		/**
		 * get the color
		 * @param {Number} val
		 */
		getGradColor(val) {
			if (val == 0) return "primary";
			else return this.gradientColor(val);
		},
	},
};
</script>
  
  <style scoped>
/* Optional custom styles here */
</style>
  